<template>
  <RosterReport v-if="userHasPermission" :useClientLayout="true" />
  <AdminLayout v-else page="Property Roster Report" title="Property Roster Report">
    You need permission to view this page.
  </AdminLayout>
</template>
<script lang="ts" setup>
import RosterReport from "../staffadmin/RosterReport.vue";
import { PermissionType } from "../../store/generatedFetchClient";
import { useUserStore } from "../../store/userStore";

var userHasPermission = computed(() =>
  useUserStore().hasPermission(PermissionType.ViewPortalRoster)
);
</script>
